class HeaderSearchSuggestionScroller extends HTMLElement {
  connectedCallback() {
    this.handleClick = this.handleClick.bind(this)
    this.updateArrow = this.updateArrow.bind(this)
    this.handleDelegatedClick = this.handleDelegatedClick.bind(this)

    requestAnimationFrame(() => {
      this.initializeElements()
      this.attachEvents()
      this.observer = new MutationObserver(() => {
        this.initializeElements()
        this.updateArrow()
      })

      this.observer.observe(this, {
        childList: true,
        subtree: true,
      })
    })
  }

  disconnectedCallback() {
    this.container?.removeEventListener('scroll', this.updateArrow)
    window.removeEventListener('resize', this.updateArrow)
    this.removeEventListener('click', this.handleDelegatedClick)
    this.observer?.disconnect()
  }

  initializeElements() {
    this.container = this.querySelector('.js-search-horizontal-scroll')
    this.rightArrow = this.querySelector('.scroll-right')
  }

  attachEvents() {
    if (!this.container) return

    this.container.removeEventListener('scroll', this.updateArrow)
    window.removeEventListener('resize', this.updateArrow)
    this.removeEventListener('click', this.handleDelegatedClick)
    this.container.addEventListener('scroll', this.updateArrow)
    window.addEventListener('resize', this.updateArrow)
    this.addEventListener('click', this.handleDelegatedClick)
    this.updateArrow()
  }

  handleDelegatedClick(e) {
    const arrow = e.target.closest('.scroll-right')
    if (!arrow) return
    if (!this.container) return

    this.handleClick()
  }

  handleClick() {
    this.container.scrollBy({
      left: this.container.clientWidth * 0.3,
      behavior: 'smooth',
    })
  }

  updateArrow() {
    if (!this.container || !this.rightArrow) return

    const maxScroll = this.container.scrollWidth - this.container.clientWidth

    if (maxScroll <= 0 || this.container.scrollLeft >= maxScroll - 5) {
      this.rightArrow.classList.add('hidden')
    } else {
      this.rightArrow.classList.remove('hidden')
    }
  }
}

customElements.define(
  'header-search-suggestion-scroller',
  HeaderSearchSuggestionScroller
)
